import { render, staticRenderFns } from "./ssr-issue-dialog.vue?vue&type=template&id=203b6254&scoped=true"
import script from "./ssr-issue-dialog.vue?vue&type=script&lang=js"
export * from "./ssr-issue-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b6254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203b6254')) {
      api.createRecord('203b6254', component.options)
    } else {
      api.reload('203b6254', component.options)
    }
    module.hot.accept("./ssr-issue-dialog.vue?vue&type=template&id=203b6254&scoped=true", function () {
      api.rerender('203b6254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/ssr-issue-dialog.vue"
export default component.exports